const inicialState = {
  page: 1,
  filter: {
    laudo: '',
    nrexame: '',
    comentario: '',
    paciente: '',
    unidades: [],
    procedimento: '',
    dataInicio: '',
    dataFim: '',
    idadeInicio: 0,
    idadeFim: 120,
    prontuario: '',
  },
};
export default inicialState;



// WEBPACK FOOTER //
// ./src/containers/BaseConhecimento/store/base.state.js